import React from 'react';
import PropTypes from 'prop-types';

import Link from '@wui/basics/link';
import Grid from '@wui/layout/grid';
import Spacer from '@wui/layout/spacer';
import Typography from '@wui/basics/typography';
import Divider from '@material-ui/core/Divider';
import VerticalDivider from '@wui/layout/verticalDivider';
import { getPhoneNumber, getEmail } from 'utils';
import { withStyles } from '@material-ui/core/styles';

import BookIcon from 'icons/svg/book.svg';

const styles = () => ({
  divider: {
    margin: [[15, 0]],
  },
  faq: {
    margin: [[0, 8]],
    color: '#39508C',
  },
});

class Help extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
  };
  static contextTypes = {
    clientDataHolder: PropTypes.shape({}),
  };
  render() {
    const {
      clientDataHolder,
      clientDataHolder: { clientData, serverData },
    } = this.context;
    const { classes } = this.props;
    return (
      <React.Fragment>
        <Typography variant="h6">Need help?</Typography>
        <Typography>Our customer support team is glad to assist you.</Typography>
        <Spacer v={16} />
        <Grid container direction="row" alignItems="center">
          {clientDataHolder.supportInfo.showSupportPhoneNumber && serverData.fromPortunus && (
            <>
              <Typography>
                <Link href={getPhoneNumber(clientData, serverData, 'link')}>
                  {getPhoneNumber(clientData, serverData)}
                </Link>
              </Typography>
              <VerticalDivider spacing={16} />
            </>
          )}
          <Typography>
            <Link href={`mailto:${getEmail()}`} aria-label={`${getEmail()} email`}>
              {getEmail()}
            </Link>
          </Typography>
        </Grid>
        <Divider className={classes.divider} />
        <Link href={`${clientDataHolder.supportInfo.faqRedirectURL}`} aria-label="FAQs">
          <Grid container direction="row" alignItems="center">
            <img alt="FAQs" src={BookIcon} />
            <Typography className={classes.faq}>Frequently Asked Questions</Typography>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M5.49775 20.4802C4.99259 20.4802 4.565 20.3052 4.215 19.9552C3.865 19.6052 3.69 19.1776 3.69 18.6725V5.28797C3.69 4.78281 3.865 4.35522 4.215 4.00522C4.565 3.65522 4.99259 3.48022 5.49775 3.48022H11.8053V4.98022H5.49775C5.42075 4.98022 5.35025 5.01231 5.28625 5.07647C5.22209 5.14047 5.19 5.21097 5.19 5.28797V18.6725C5.19 18.7495 5.22209 18.82 5.28625 18.884C5.35025 18.9481 5.42075 18.9802 5.49775 18.9802H18.8823C18.9593 18.9802 19.0298 18.9481 19.0938 18.884C19.1579 18.82 19.19 18.7495 19.19 18.6725V12.365H20.69V18.6725C20.69 19.1776 20.515 19.6052 20.165 19.9552C19.815 20.3052 19.3874 20.4802 18.8823 20.4802H5.49775ZM9.90925 15.3147L8.8555 14.261L18.1363 4.98022H14.19V3.48022H20.69V9.98022H19.19V6.03398L9.90925 15.3147Z"
                fill="#39508C"
              />
            </svg>
          </Grid>
        </Link>
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(Help);
